import { signal } from "@angular/core";

export const firstSetup = signal(false);
